(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/delegations/delegations.tpl.html', [
'<!--',
'',
' * Copyright (C) 2009-2026 by the geOrchestra PSC',
' *',
' * This file is part of geOrchestra.',
' *',
' * geOrchestra is free software: you can redistribute it and/or modify it under',
' * the terms of the GNU General Public License as published by the Free',
' * Software Foundation, either version 3 of the License, or (at your option)',
' * any later version.',
' *',
' * geOrchestra is distributed in the hope that it will be useful, but WITHOUT',
' * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or',
' * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for',
' * more details.',
' *',
' * You should have received a copy of the GNU General Public License along with',
' * geOrchestra.  If not, see <http://www.gnu.org/licenses/>.',
' ',
'-->',
'',
'<section class="delegations" ng-if="profile === \'SUPERUSER\'">',
'',
'  <div class="col-md-12">',
'',
'    <input type="text" class="filter-table form-control pull-right" ng-model="delegations.q" placeholder="{{\'delegations.filter\' | translate}}"></input>',
'    <i class="glyphicon glyphicon-remove-sign filter-table-reset" ng-show="delegations.q != \'\'" ng-click="delegations.q = \'\'"></i>',
'    <h3 class="delegations-title">',
'      <ng-pluralize count="delegations.delegations.length"',
'                    when="{\'0\': \'{{ &quot;delegations.title_no_delegations&quot; | translate }}\',',
'                           \'1\': \'{} {{ &quot;delegations.title&quot; | translate }}\',',
'                           \'other\': \'{} {{ &quot;delegations.title_plural&quot; | translate }}\'}">',
'      </ng-pluralize>',
'    </h3>',
'',
'    <table class="table table-striped table-condensed">',
'',
'      <thead>',
'        <tr>',
'          <th translate>home.user</th>',
'          <th translate>nav.orgs</th>',
'          <th translate>nav.roles</th>',
'        </tr>',
'      </thead>',
'',
'      <tbody>',
'        <tr dir-paginate="delegation in delegations.delegations | filter:delegations.q | itemsPerPage: delegations.itemsPerPage">',
'          <td style="max-width: 15vw">',
'            <a ng-link="user({id: delegation.uid, tab: \'delegations\'})" class="break-word">{{::(delegations.users[delegation.uid] ? delegations.users[delegation.uid] : delegation.uid)}}</a>',
'          </td>',
'          <td>',
'            <span ng-repeat="org in delegation.orgs">',
'            <a ng-link="org({org: org, tab: \'infos\'})">{{ delegations.orgs[org].name }}</a>{{$last ? \'\' : \', \'}}',
'            </span>',
'          </td>',
'          <td>',
'            <span ng-repeat="role in delegation.roles">',
'              <a ng-link="role({role: role, tab: \'infos\'})">{{ role }}</a>{{$last ? \'\' : \', \'}}',
'            </span>',
'          </td>',
'        </tr>',
'      </tbody>',
'',
'    </table>',
'',
'    <dir-pagination-controls></dir-pagination-controls>',
'',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();